import type { AddressModel } from '@sosocio/creator-types/project';
import { formatAddress as formatAddressLines } from '@sosocio/tools/address';
import { AppDataModule } from 'store';

/**
 * Resolves Creator's country metadata and delegates deterministic postal line
 * assembly to the shared address tool.
 *
 * @param addressModel Project {@link AddressModel} rendered by Creator.
 * @returns Ordered postal lines with Creator's translated country name when available.
 */
export default function formatAddress(addressModel: AddressModel): string[] {
	const countryModel = (
		addressModel.country
			? AppDataModule.findCountryWhere({
				iso: addressModel.country.trim(),
			})
			: undefined
	);

	return formatAddressLines(
		addressModel,
		countryModel
			? {
				name: (
					addressModel.countryFormatted
						? countryModel.name
						: AppDataModule.getCountryName(countryModel.id)
				),
				states: countryModel.states,
			}
			: undefined,
	);
}
